export const QC_ASSAY_SUMMARY_DATA_FETCHING = 'QC_ASSAY_SUMMARY_DATA_FETCHING';
export const QC_ASSAY_SUMMARY_DATA_FETCHED = 'QC_ASSAY_SUMMARY_DATA_FETCHED';
export const QC_ASSAY_SUMMARY_DATA_FETCHING_FAILED = 'QC_ASSAY_SUMMARY_DATA_FETCHING_FAILED';
export const QC_ASSAY_STATE_ADD="QC_ASSAY_STATE_ADD";
export const QC_ASSAY_STATE_REMOVE="QC_ASSAY_STATE_REMOVE";

export const QC_ERROR_API_ERROR = "Error occurred while getting QC Assay Summary";
export const TEST_FIELD = "assayName";
export const IS_PASSED_FIELD = "levelStatus";
export const LOT_EXP_DATE = "lotExpLocal";